const openMobileMenu = () => {

    const button = document.querySelector('.mobile-menu-button');
    const menu = document.querySelector('header .mobile-header');

    const burgerIcon = button.querySelector('.burger');
    const closeIcon = button.querySelector('.close');

    button.addEventListener('click', (e) => {
        e.preventDefault();

        if(!menu.classList.contains('show')){
            menu.classList.add('show');
            burgerIcon.classList.add('hidden');
            closeIcon.classList.remove('hidden');
        } else {
            menu.classList.remove('show');
            closeIcon.classList.add('hidden');
            burgerIcon.classList.remove('hidden');
        }
    })

}
export default openMobileMenu